import { render, staticRenderFns } from "./NewSupportOrganizationPage.vue?vue&type=template&id=b9ddafde&"
import script from "./NewSupportOrganizationPage.vue?vue&type=script&lang=js&"
export * from "./NewSupportOrganizationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports